import React, { forwardRef } from 'react'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        aria-invalid={error ? true : undefined}
        className={`field min-h-32 resize-none overflow-y-auto ${className || ''}`}
        {...props}
      />
    )
  }
)

Textarea.displayName = 'Textarea'

export { Textarea }
